// Set VITE_S3_BASE_URL to the CloudFront distribution URL (from AssetsCDNUrl CDK output).
// Falls back to the direct S3 URL for local dev.
export const S3_BASE_URL =
  import.meta.env.VITE_S3_BASE_URL ||
  "https://s3stack-pokelands2543037f-vzpo47bgwuoz.s3.us-east-1.amazonaws.com";
